import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const WHATSAPP = "919626102030";
export const PHONE = "+91 96261 02030";
export const QR_URL = "https://customer-assets-7cd3h4nn.emergentagent.net/job_goa-club-tickets/artifacts/4t24psv1_image.png";
export const MAPS_URL = "https://www.google.com/maps/dir//Soho+Goa+-+Nightclub,+Calangute+-+Baga+Rd,+Baga,+Arpora,+Goa+403516/@28.580172,77.3668959,15z/data=!3m1!4b1!4m8!4m7!1m0!1m5!1m1!1s0x3bbfeb005f19e8c5:0xb579348a7ae79712!2m2!1d73.7518299!2d15.5637371?entry=ttu&g_ep=EgoyMDI2MDgxOS4wIKXMDSoASAFQAw%3D%3D";
export const parsePrice = (value) => { const match = String(value || "").match(/\d[\d,]*/); return match ? Number(match[0].replace(/,/g, "")) : 0; };

export const slugify = (text) => String(text || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

const MONTH_INDEX = { JAN: 0, FEB: 1, MAR: 2, APR: 3, MAY: 4, JUN: 5, JUL: 6, AUG: 7, SEP: 8, OCT: 9, NOV: 10, DEC: 11 };

export const eventISO = (event) => {
  const day = (String(event.date || "").match(/\d{1,2}/) || [])[0];
  const monthKey = (String(`${event.date || ""} ${event.month || ""}`).toUpperCase().match(/JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC/) || [])[0];
  if (!day || monthKey === undefined) return null;
  const now = new Date();
  const d = new Date(now.getFullYear(), MONTH_INDEX[monthKey], Number(day), 21, 0, 0);
  if ((now - d) / 86400000 > 45) d.setFullYear(d.getFullYear() + 1);
  return d.toISOString();
};

const STANDARD_EVENTS = {
  cover_charge_submit: "Purchase",
  cover_charge_click: "InitiateCheckout",
  table_reservation_start: "Contact",
  call_click: "Contact",
};

export const trackEvent = (name, params = {}) => {
  if (window.fbq) {
    window.fbq("trackCustom", name, params);
    if (STANDARD_EVENTS[name]) window.fbq("track", STANDARD_EVENTS[name], params);
  }
};

export const logClick = (type, event = "") => {
  axios.post(`${API}/track`, { type, event }).catch(() => {});
};

export const openWhatsApp = (message = "Hi Soho Goa, I'd like to reserve a table.", event = "") => {
  trackEvent("table_reservation_start", { channel: "whatsapp", ...(event ? { event_name: event } : {}) });
  logClick("whatsapp", event);
  window.open(`https://wa.me/${WHATSAPP}?text=${encodeURIComponent(message)}`, "_blank");
};

export const fallbackEvents = [
  { id: "saturday-sutra", date: "14", month: "JUN", weekday: "SATURDAY", title: "Sutra Saturdays", genre: "House · Techno · Disco", time: "10 PM — 3 AM", price: "₹999", image: "https://images.pexels.com/photos/5192307/pexels-photo-5192307.jpeg", featured: true },
  { id: "neon-nights", date: "21", month: "JUN", weekday: "SATURDAY", title: "Neon Nights", genre: "Hip-hop · R&B · Open format", time: "9 PM — 2 AM", price: "₹799", image: "https://images.unsplash.com/photo-1611105849269-e3c1815fea47?auto=format&fit=crop&w=900&q=85" },
  { id: "sunday-social", date: "22", month: "JUN", weekday: "SUNDAY", title: "The Sunday Social", genre: "Chill house · Sunset sessions", time: "5 PM — 11 PM", price: "₹499", image: "https://images.unsplash.com/photo-1688591677634-58dfdc60d62d?auto=format&fit=crop&w=900&q=85" },
];
